import { render, staticRenderFns } from "./ClientProductDetail.vue?vue&type=template&id=86143de4&"
import script from "./ClientProductDetail.vue?vue&type=script&lang=js&"
export * from "./ClientProductDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports